import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { DatadogRumService } from './app/shared/services/datadog-rum.service';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
    .then(appRef => {
        const rumService = appRef.injector.get(DatadogRumService);
        rumService.init();
    })
    .catch(err => console.error(err));